import hasDom from 'has-dom';
import validatePaymentsInfo from './validatePaymentsInfo.js';
import syncWithWalletStorage from './syncWithWalletStorage.js';
import getWalletTenantConfig from './getWalletTenantConfig.js';
import debugWallet from './debugWallet.js';
import updateWalletStorage from './updateWalletStorage.js';
function handleWalletId(_ref) {
  let {
    paymentInfoWithDefaults,
    walletIdFromStorage,
    walletStorageService
  } = _ref;
  // If no wallet id in payments, but local storage value is present, copy that value
  if (!paymentInfoWithDefaults?.walletId && walletIdFromStorage) {
    paymentInfoWithDefaults.walletId = walletIdFromStorage?.replace(/['"]+/g, '');
  }
  if (paymentInfoWithDefaults?.walletId && !walletIdFromStorage) {
    walletStorageService.setWalletId(paymentInfoWithDefaults?.walletId?.replace(/['"]+/g, ''));
  }

  // NOTE: Test wallet id for extra quotes in the value. If present strip them from the value and reassign
  if (walletIdFromStorage && /['||"]/.test(walletIdFromStorage)) {
    walletStorageService.setWalletId(walletIdFromStorage.replace(/['"]+/g, ''));
  }
  let isManualSync = false;
  let importedWalletId;
  if (hasDom()) {
    // Check if user has been redirected from Wallet Central to import their settings
    const {
      searchParams
    } = new URL(window.location.href);
    importedWalletId = searchParams.get('wallet_id');

    // assign the imported wallet id to paymentInfo
    if (importedWalletId && importedWalletId !== paymentInfoWithDefaults.walletId) {
      paymentInfoWithDefaults.walletId = importedWalletId;
      walletStorageService.setWalletId(importedWalletId);
      isManualSync = true;
      if (window?.history?.replaceState) {
        searchParams.delete('wallet_id');
        window.history.replaceState(window.history.state, '', window.location.pathname + '?' + searchParams.toString());
      }
    }
  }
  return {
    isManualSync,
    importedWalletId
  };
}
async function hydrateWallet(_ref2) {
  let {
    walletStorageService,
    prevPaymentsInfo = {},
    myWalletConfigs = {},
    walletDefaults = {}
  } = _ref2;
  const paymentInfoWithDefaults = validatePaymentsInfo(prevPaymentsInfo, myWalletConfigs, walletDefaults);
  const {
    tenant = ''
  } = walletDefaults;
  const walletIdFromStorage = walletStorageService.getWalletId();
  const {
    isManualSync
  } = handleWalletId({
    paymentInfoWithDefaults,
    walletIdFromStorage,
    walletStorageService
  });
  const syncedPayments = await syncWithWalletStorage({
    walletStorageService,
    paymentInfo: {
      ...paymentInfoWithDefaults
    },
    isManualSync
  });
  const response = {
    ...syncedPayments
  };

  // set isPaymentsInfoLoaded flag
  response.paymentInfo.isPaymentsInfoLoaded = true;
  if (tenant) {
    const tenantConfig = getWalletTenantConfig(tenant);
    const {
      defaultCreditType,
      ...displayConfigs
    } = tenantConfig || {};
    response.paymentInfo = {
      ...response.paymentInfo,
      tenant,
      ...(defaultCreditType && {
        creditType: defaultCreditType
      }),
      myWallet: {
        ...response.paymentInfo.myWallet,
        displayConfigs
      }
    };
  }
  if (response.paymentInfo?.interactions?.syncAlert?.showAlert) {
    debugWallet('wallet is successfully synced - update wallet storage with the alert message');

    // push alerts to wallet storage
    updateWalletStorage({
      walletStorageService,
      payload: {
        ...response.paymentInfo
      }
    });
  }
  if (!response.paymentInfo?.walletId && (!!walletStorageService?.walletIdCache?.getItem() || !!walletIdFromStorage)) {
    response.paymentInfo = {
      ...response.paymentInfo,
      walletId: walletStorageService.walletIdCache.getItem()
    };
  }
  return response;
}
export { hydrateWallet as default };
